import { createAction, props } from '@ngrx/store';
import { partnerPlant } from 'src/app/pages/orders/interfaces/partnerPlants.interface';

export const loadPartnerPlants = createAction('[Partner Plants] Load', props<{ podId: number }>());

export const loadPartnerPlantsSuccess = createAction(
  '[Partner Plants] Load Success',
  props<{ response: partnerPlant[] }>(),
);

export const loadPartnerPlantsSuccessByKey = createAction(
  '[Partner Plants] Load Success By Key',
  props<{ key: string; response: partnerPlant[] }>(),
);

export const loadPartnerPlantsFailure = createAction('[Partner Plants] Load Failure', props<{ error: any }>());

export const resetPartnerPlantsState = createAction('[Partner Plants] Reset');
